import { ComponentWithPermissions } from '../../../../../../../../baseComponents/CreateRoutering/types'
import TwinFileSystem from '../../../../../../../../baseComponents/TwinFileSystem'
import { SupplierModelType } from '@teinor/erp/types/company/supplier'

interface SupplierFilesProps extends ComponentWithPermissions {
    basicData: SupplierModelType | null
}

const SupplierFiles: React.FC<SupplierFilesProps> = ({ userPermissions, basicData }) => {
    if (basicData?.id) {
        return (<TwinFileSystem subFolder={'/' + basicData.id+'/supplierFolder'} type='supplier' userPermissions={userPermissions}></TwinFileSystem>)
    }
    return null
}

export default SupplierFiles